// extracted by mini-css-extract-plugin
module.exports = {"text":"OverlayTitle_text_25Yd9","line":"OverlayTitle_line_Cgt6w"};
    if(module.hot) {
      // 1789136764466
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  